import React, { useState } from 'react';
import Highlight, { defaultProps } from 'prism-react-renderer';
import { theme } from './outputTheme';
import {
  CodeBlockContainer,
  Pre,
  Header,
  Caption,
  Spacer,
  CopyButtonContainer,
  CopyButton,
  CodeContent,
  Fade
} from './styled';
import { FaRegCopy } from 'react-icons/fa';

const lineNumberPattern = /{([\d,-]+)}/;

const calculateLinesToHighlight = (meta) => {
  if (!lineNumberPattern.test(meta)) {
    return () => false;
  }
  const lineNumbers = lineNumberPattern
    .exec(meta)[1]
    .split(',')
    .map((v) => v.split('-').map((x) => parseInt(x, 10)));
  return (index) => {
    const lineNumber = index + 1;
    const inRange = lineNumbers.some(([start, end]) =>
      end ? lineNumber >= start && lineNumber <= end : lineNumber === start
    );
    return inRange;
  };
};

export function CodeBlock({ code, language, metaString, caption }) {
  const [copySuccess, setCopySuccess] = useState('');
  const shouldHighlightLine = calculateLinesToHighlight(metaString);

  const copyToClipboard = (e) => {
    e.preventDefault();
    navigator.clipboard.writeText(code).then(
      () => {
        setCopySuccess('Copiado!');
        setTimeout(() => setCopySuccess(''), 2000);
      },
      (err) => {
        setCopySuccess('Falha ao copiar!', err.message);
        setTimeout(() => setCopySuccess(''), 2000);
      }
    );
  };

  return (
    <CodeBlockContainer>
      <Highlight
        {...defaultProps}
        code={code}
        language={language}
        theme={theme}
      >
        {({ className, style, tokens, getLineProps, getTokenProps }) => (
          <div
            className={`relative ${className}`}
            style={{ ...style, borderRadius: '8px', overflow: 'hidden' }}
          >
            <Pre>
              <Header>
                <Caption>
                  {caption || JSON.stringify(language).replace(/['"]+/g, '')}
                </Caption>
                <Spacer />
                <CopyButtonContainer>
                  <CopyButton onClick={copyToClipboard}>
                    {copySuccess || <FaRegCopy />}
                  </CopyButton>
                </CopyButtonContainer>
              </Header>
              <CodeContent>
                <span>
                  {tokens.map((line, i) => {
                    const lineProps = getLineProps({ line, key: i });

                    if (shouldHighlightLine(i)) {
                      lineProps.className = `${lineProps.className} highlight-line`;
                    }

                    return (
                      <div key={i} {...lineProps}>
                        {line.map((token, key) => (
                          <span key={key} {...getTokenProps({ token, key })} />
                        ))}
                      </div>
                    );
                  })}
                </span>
              </CodeContent>
              <Fade />
            </Pre>
          </div>
        )}
      </Highlight>
    </CodeBlockContainer>
  );
}
